import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { clienteId: String, referidoId: String }

  connect() {
    this.#updateFonte(this.#fonteHidden()?.value ?? "")
  }

  toggle(event) {
    const value = event.detail?.value ?? event.target?.value ?? ""
    this.#updateFonte(value)
  }

  toggleRepresentante(event) {
    document.getElementById("div_representante")
      ?.classList.toggle("hidden", !event.target.checked)
  }

  #fonteHidden() {
    return this.element.querySelector("input[name='cliente[fonte_id]'][data-ui--combobox-target='hidden']")
  }

  #indicacaoHidden() {
    return this.element.querySelector("input[name='cliente[indicacao_id]'][data-ui--combobox-target='hidden']")
  }

  #updateFonte(value) {
    const clienteDiv  = document.getElementById("div_fonte_cliente_id")
    const referidoDiv = document.getElementById("div_fonte_referido_id")
    if (clienteDiv)  clienteDiv.style.display  = value !== "" && value === this.clienteIdValue  ? "" : "none"
    if (referidoDiv) referidoDiv.style.display = value !== "" && value === this.referidoIdValue ? "" : "none"
  }
}
